<template>
  <div class="flexCss list-box common-shadow" style="margin: 20px">
    <vxe-form
        ref="xForm"
        class="my-form3"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules"
        style="margin-top: 20px; padding: 0 36px;width: 100%;display: flex; flex-direction: column;align-items: center;"
        @submit="submitEvent">
      <div class="infoCssPadding">
        <div>
          <div class="border-shadow">
            <Row>
              <Col span="8">
                <vxe-form-item title="注册手机号" field="regisiterNum" :title-width="110" title-align="right" span="8">
                  <template v-slot="scope">
                    <div style="display: flex;align-items: center;">
                      <i-switch
                          class="re-switch"
                          v-model="formData.isSystemPhone"
                          @on-change="changePhoneType"
                          false-color="#AAABAB"
                          size="large"
                      >
                        <span slot="open"></span>
                        <span slot="close">系统号</span>
                      </i-switch>
                      <vxe-input class="formInput" v-model="formData.regisiterNum" placeholder="用户登录手机号勿乱填"
                                 @input="$refs.xForm.updateStatus(scope)" @blur="checkRegisiter"
                                 :disabled="formData.isSystemPhone"></vxe-input>
                      <!-- <Poptip trigger="hover" placement="top">
                        <i class="vxe-icon--question" style="margin-left: 5px;cursor: pointer;"></i>
                        <template slot="content">
                          <div>
                               <span>1. 空号即为近一个月内出现过空号的号码<br>
                                2. 停机即为近一个月内出现过停机的号码（命中准确率100%，误差率5%)。出现误差的原因：可能停机的手机号恢复使用<br>
                                3. 查询无记录是指利用API接口检测中，系统无法在数据库中查询到该号码<br>
                                4. 沉默号里面分为两种状态，一种是超过半年没有激活过的空号，二是近三月流量均消耗低于30M，且近三个月平均流量低于<br>
                                30M的用户也有可能随时停机，简单的来说就是快投入市场的空号、小号、新号、非智能机客户，我们认为这种是对移动互联网<br>
                                没有太大的兴趣人群<br>
                                5. 风险号属于长时间关机或未开通语音服务以及易投诉的用户<br></span>
                          </div>
                        </template>
                      </Poptip> -->
                    </div>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="身份类型" field="userCategoryStr" :title-width="150" title-align="right">
                  <template>
                    <vxe-select
                        style="width: 300px"
                        v-model="formData.userCategoryStr"
                        placeholder="请选择"
                        :options="userCategoryType"
                        transfer
                        multiple
                        @change="clickUserCategory($event)"
                    ></vxe-select>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="备用联系方式" field="phoneNum" :title-width="150" title-align="right" span="8">
                  <vxe-input class="formInput" v-model="formData.phoneNum" placeholder="请输入联系方式"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="infoCssPadding">
        <div>
          <div class="bit">
            <img src="@/assets/images/common/per.png"/>
            <span class="bit-title">个人信息:</span>
          </div>
          <div class="border-shadow">
            <Row>
              <Col span="8">
                <vxe-form-item title="身份证正面" field="idcardFrontUrl" :title-width="150" title-align="right" span="8">
                  <upload-img :row="formData" :fileKey="'idcardFrontUrl'" :width="58" :height="58" :readOnly="authTrue"
                              :initFile="formData.idcardFrontUrl" :isOcrIdCard="true" :isFront="true"
                              @getOcrIdCard="getOcrIdCard"></upload-img>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="身份证反面" field="idcardBackUrl" :title-width="150" title-align="right" span="8">
                  <upload-img :row="formData" :fileKey="'idcardBackUrl'" :width="58" :height="58" :readOnly="authTrue"
                              :initFile="formData.idcardBackUrl"></upload-img>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="姓名" field="realName" :title-width="150" title-align="right" span="8">
                  <template #title>
                    <span style="color: #f56c6c;">*</span>
                    <span>姓名</span>
                  </template>
                  <template v-slot="scope">
                    <vxe-input class="formInput" v-model="formData.realName" placeholder="请输入姓名" :readonly="authTrue"
                               @input="$refs.xForm.updateStatus(scope)"></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="身份证号" field="idcardNum" :title-width="150" title-align="right" span="8">
                  <template v-slot="scope">
                    <vxe-input class="formInput" v-model="formData.idcardNum" placeholder="请输入身份证号" :readonly="authTrue"
                               @input="inputIdCardNum(scope)"></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="证件地址" field="regAddr" :title-width="150" span="8" title-align="right">
                  <vxe-input class="formInput" v-model="formData.regAddr" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
          <div class="bit" v-show="formData.userCategoryStr.indexOf('司机') > -1">
            <img src="@/assets/images/common/driver.png"/>
            <span class="bit-title">驾驶证信息:</span>
          </div>
          <div class="border-shadow" v-show="formData.userCategoryStr.indexOf('司机') > -1">
            <Row>
              <Col span="8">
                <vxe-form-item title="驾驶证正面" field="drivingCardFrontUrl" :title-width="150" title-align="right">
                  <upload-img :row="formData" :fileKey="'drivingCardFrontUrl'" :width="58" :height="58"
                              :readOnly="driverTrue"
                              :initFile="formData.drivingCardFrontUrl" :isOcrDriving="true" :isFront="true"
                              @getOcrDriving="getOcrDriving"></upload-img>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="驾驶证副面" field="drivingCardSubpageUrl" :title-width="150" title-align="right">
                  <upload-img :row="formData" :fileKey="'drivingCardSubpageUrl'" :width="58" :height="58"
                              :readOnly="driverTrue"
                              :initFile="formData.drivingCardSubpageUrl" :isOcrDriving="true"
                              @getOcrDriving="getOcrDriving"></upload-img>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="驾驶证号" field="driverCardNum" :title-width="150" title-align="right" span="8">
                  <vxe-input class="formInput" v-model="formData.driverCardNum" disabled></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="准驾车型" field="driverModel" :title-width="150" title-align="right" span="8">
                  <Select v-model="formData.driverModel" class="formInput" :disabled="driverTrue">
                    <Option v-for="(item,index) in driver_model" :value="item.value" :key="index">{{ item.label }}
                    </Option>
                  </Select>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="驾驶证发证机关" field="issueAuthority" :title-width="150" title-align="right" span="8">
                  <vxe-input class="formInput" v-model="formData.issueAuthority" placeholder="请输入驾驶证发证机关"
                             :disabled="driverTrue"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="驾驶证有效期自" field="driverBeginTime" :title-width="150" title-align="right"
                               span="8">
                  <vxe-input class="formInput" type="date" v-model="formData.driverBeginTime" :disabled="driverTrue"
                             placeholder="请选择日期"></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="驾驶证有效期至" field="driverExpireTime" :title-width="150" title-align="right"
                               span="8">
                  <vxe-input class="formInput" type="date" v-model="formData.driverExpireTime" :disabled="driverTrue"
                             placeholder="请选择日期"></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="所驾驶车辆总重量" field="weightType" :title-width="150" title-align="right" span="8">
                  <Select v-model="formData.weightType" class="formInput" :disabled="driverTrue">
                    <Option v-for="(item,index) in weight_type" :value="item.value" :key="index">{{ item.label }}
                    </Option>
                  </Select>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
          <div class="bit" v-show="formData.userCategoryStr.indexOf('司机') > -1">
            <img src="@/assets/images/common/cyzgz.png"/>
            <span class="bit-title">从业资格证信息:</span>
          </div>
          <div class="border-shadow" v-show="formData.userCategoryStr.indexOf('司机') > -1">
            <Row>
              <Col span="8">
                <vxe-form-item title="从业资格证" field="qualificationUrl" :title-width="150" title-align="right" span="8">
                  <upload-img :row="formData" :fileKey="'qualificationUrl'" :width="58" :height="58"
                              :readOnly="driverTrue"
                              :initFile="formData.qualificationUrl"></upload-img>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="从业资格证号" field="transportLicenseNum" :title-width="150" title-align="right"
                               span="8">
                  <div style="height: 80px;display: flex;align-items: center;">
                    <vxe-input class="formInput" v-model="formData.transportLicenseNum" disabled></vxe-input>
                  </div>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="从业资格证有效期至" field="transportExpireTime" :title-width="150" title-align="right"
                               span="8">
                  <div style="height: 80px;display: flex;align-items: center;">
                    <vxe-input class="formInput" type="date" v-model="formData.transportExpireTime"
                               :disabled="driverTrue"
                               placeholder="请选择日期"></vxe-input>
                  </div>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="infoCssPadding">
        <div>
          <div class="bit">
            <img src="@/assets/images/common/bank.png"/>
            <span class="bit-title">银行账户:</span>
          </div>
          <div class="border-shadow">
            <vxe-table
                style="margin-top: 10px;width:100%;"
                ref="xBankTable"
                border
                show-overflow
                size="mini"
                :data="tableData"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
            >
              <vxe-table-column width="50" align="center">
                <template v-slot:header>
                  <Button class="add-btn" icon="md-add" @click="insertEvent()"></Button>
                </template>
                <template v-slot="{ row }">
                  <Button class="del-btn" icon="md-remove" @click="delRow(row)"></Button>
                </template>
              </vxe-table-column>
              <vxe-table-column field="accountName" title="户名">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.accountName" placeholder="选填" maxlength="30"
                             @input="(file)=>checkAccName(file,row)" @blur="(file)=>checkAccRule(file,row)"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="openBankName" title="开户行">
                <template v-slot="{ row,$rowIndex }">
                  <vxe-pulldown :ref="'bankDown'+ $rowIndex" transfer style="width: 100%">
                    <template v-slot>
                      <vxe-input v-model="row.openBankName" placeholder="请选择开户行"
                                 @focus="bankFocusEvent(row,'bankDown'+ $rowIndex)"
                                 @keyup="bankKeyupEvent(row)" @blur="checkOrg(row)"></vxe-input>
                    </template>
                    <template v-slot:dropdown>
                      <div class="my-dropdown1">
                        <div class="list-item1" v-for="item in bankList" :key="item.id"
                             @click="bankSelectEvent(item,row,'bankDown'+ $rowIndex)">
                          <i class="fa fa-user-o"></i>
                          <span>{{ item.orgName }}</span>
                        </div>
                      </div>
                    </template>
                  </vxe-pulldown>
                </template>
              </vxe-table-column>
              <vxe-table-column field="accountNum" title="银行账号">
                <template v-slot="{ row }">
                  <vxe-input
                      v-model="row.accountNum"
                      placeholder="选填"
                      @input="(file)=>checkAccNum(file,row)"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column title="是否默认" field="isDefault">
                <template v-slot="{ row,$rowIndex }">
                  <!--                  <vxe-switch v-model="row.isDefault" open-label="是" close-label="否" open-value="1" close-value="0"></vxe-switch>-->
                  <vxe-select v-model="row.isDefault" placeholder="是否默认" clearable transfer
                              @change="isDefaultChange(row,$rowIndex)">
                    <vxe-option :value=1 label="是"></vxe-option>
                    <vxe-option :value=0 label="否"></vxe-option>
                  </vxe-select>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
        <div>
          <div class="bit">
            <img src="@/assets/images/common/addres.png"/>
            <span class="bit-title">邮寄地址:</span>
          </div>
          <div class="border-shadow">
            <vxe-table
                style="margin-top: 10px;width:100%;"
                ref="xEmailTable"
                border
                show-overflow
                size="mini"
                :data="tableData2"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
            >
              <vxe-table-column width="50" align="center">
                <template v-slot:header>
                  <Button class="add-btn" icon="md-add" @click="insertEvent2()"></Button>
                </template>
                <template v-slot="{ row }">
                  <Button class="del-btn" icon="md-remove" @click="delRow2(row)"></Button>
                </template>
              </vxe-table-column>
              <vxe-table-column field="linkMan" title="联系人">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.linkMan" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="linkPhone" title="联系电话">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.linkPhone" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="pro" title="省市区">
                <template v-slot="{ row }">
                  <Cascader
                      v-model="row.pro"
                      :data="home_port"
                      trigger="hover"
                      transfer
                  ></Cascader>
                </template>
              </vxe-table-column>
              <vxe-table-column field="content" title="详细地址">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.content" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
      </div>
      <vxe-form-item align="center" span="24" style="margin-top: 20px">
        <vxe-button status="primary" @click="close">取消</vxe-button>
        <vxe-button type="submit" status="primary">完成</vxe-button>
      </vxe-form-item>
    </vxe-form>
    <vxe-modal v-model="wyTip" position="center" title="消息通知">
      <div style="display: flex; flex-direction: column">
        <div style="display: flex; align-items: center">
          <img v-if="msgErr" src="@/assets/images/common/msgSuccess.png" style="width: 22px;height: 22px;"/>
          <img v-else src="@/assets/images/common/info.png" style="width: 22px;height: 22px;"/>
          <span style="margin-left: 10px">{{ msg }}</span>
        </div>
        <div style="margin-left: auto; margin-top: 20px">
          <Button style="border-radius: 5px" @click="cancelCreate">返回编辑</Button>
          <Button type="primary" style="margin-left: 10px; border-radius: 5px" @click="createAndSaveBaseUserSign">继续创建
          </Button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>
<script>
import UploadImg from "@/components/common/UploadImg";
import {hideLoading, isEmpty, showLoading} from "@/utils/util";
import $api from "@/apiProvider";
import $C from "@/consts";
import md5 from "js-md5";

export default {
  components: {UploadImg},
  data() {
    return {
      wyTip: false,
      msgErr: false,
      msg: '',
      formData: {
        compName: null,
        faxNum: null,
        idcardNum: null,
        idCardExpireTime: null,
        regisiterNum: null,
        driverCardNum: null,
        driverModel: null,
        issueAuthority: null,
        driverBeginTime: null,
        driverExpireTime: null,
        weightType: null,
        transportLicenseNum: null,
        transportExpireTime: null,
        phoneNum: null,
        realName: null,
        idcardBackUrl: null,
        userTypeDisd: true,
        idcardFrontUrl: null,
        businessUrl: null,
        transportLicenseUrl: null,
        businessExpireTime: null,
        businessLicenseNum: null,
        qualificationUrl: null,
        drivingCardFrontUrl: null,
        drivingCardSubpageUrl: null,
        regAddr: null,
        nextError: false,
        regPhone: null,
        taxNum: null,
        accountName: null,
        accountNum: null,
        userType: 1,
        userCategoryStr: [],
        managerType: null,
        managerPhone: null,
        managerName: null,
        isSystemPhone: false,
        userAddressBankInfo: [
          {
            accountName: null,
            accountNum: null,
            openBankName: null,
            openOrgNum: null
          },
        ],
        userAddressInfor: [
          {
            content: null,
            linkMan: null,
            linkPhone: null,
          },
        ],
      },
      fileOptions: $C.HAS_FILE_TYPE.options,
      formRules: {
        realName: [{required: true, message: "请输入名称"}, {min: 2, max: 15, message: '请输入正确的名称'}],
        nickname: [{required: true, message: "请输入昵称"}],
        userCategoryStr: [{required: true, message: "请选择身份类型"}],
        idcardNum: [
          {min: 18, max: 18, message: '请输入正确的身份证号'}
        ],
        driverCardNum: [
          {min: 18, max: 18, message: '请输入正确的驾驶证号'}
        ],
        transportLicenseNum: [
          {min: 18, max: 18, message: '请输入正确的从业资格证号'}
        ],
        taxNum: [
          {min: 18, max: 18, message: '请输入正确的统一社会信用码'},
          {required: true, message: "请输入统一社会信用码"}
        ],
        managerPhone: [{min: 11, max: 11, message: '请输入正确的手机号'}],
        regisiterNum: [{required: true, message: '请输入注册手机号'}, {min: 11, max: 11, message: '请输入正确的手机号'}],
        // regAddr: [
        //   {required: true, message: '请输入地址'}
        // ]
      },
      userCategoryType: [{
        label: '货主',
        value: '货主'
      },
        {
          label: '船东',
          value: '船东'
        },
        {
          label: '司机',
          value: '司机'
        },
        {
          label: '代理',
          value: '代理'
        },
        {
          label: '船员',
          value: '船员'
        },
        {
          label: '供应商',
          value: '供应商'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      driver_model: [],
      weight_type: [{
        label: '大于4.5吨',
        value: 1,
      }, {
        label: '小于等于4.5吨',
        value: 2,
      }],
      tableData: [{
        isDefault: 1
      }],
      tableData2: [{
        pro: []
      }],
      bankList: [],
      home_port: [],
      regisiterNumState: null,
      authTrue: false,
      driverTrue: false,
    }
  },
  mounted() {
    document.title = '创建个人客户';
    this.getDicUserCategoryList();
    this.getHomePort();
    this.getDict(40500, 'driver_model');
  },
  methods: {
    changePhoneType(e) {
      this.formData.regisiterNum = null;
      this.$refs.xForm.clearValidate();
    },
    checkAccName(e, row) {
      row.accountName = e.replace('(', '（').replace(')', '）');
    },
    checkAccNum(e, row) {
      row.accountNum = e.replace(/[^\d]/g, '');
    },
    checkAccRule(e, row) {
      let reg = new RegExp(/^[\u4e00-\u9fa5（）]+$/);
      let valid = reg.test(e.value);
      if (e.value.length < 2 || e.value.length > 30 || !valid) {
        this.$XModal.alert({
          message: "请输入正确的户名",
          status: "error",
        });
        row.accountName = null;
        return;
      }
    },
    checkRegisiter() {
      let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
      let validPhone = regPhone.test(this.formData.regisiterNum);
      if (!validPhone) {
        this.$XModal.alert({
          message: "请输入正确的注册手机号",
          status: "error",
        });
        return;
      }
      this.queryUserInfoClientDetail();
    },
    async queryUserInfoClientDetail() {
      let res = await $api.gcdUser.request("queryUserInfoClientDetail", {loginName: this.formData.regisiterNum});
      if (res.status === 1) {
        if (res.data.userIdGyl) {
          this.$XModal.alert({
            message: "该手机号已存在",
            status: "error",
          });
          return;
        }
        if (res.data.authStatus === 3) {
          this.authTrue = true;
        } else {
          this.authTrue = false;
        }
        if (res.data.identityStatus === 3) {
          this.driverTrue = true;
        } else {
          this.driverTrue = false;
        }

        if (res.data.tagsStr) {
          this.formData.userCategoryStr = res.data.tagsStr.split(',');
        }

        if (res.data.realName) {
          this.$set(this.formData, 'realName', res.data.realName);
        }
        if (res.data.isSystemPhone) {
          this.$set(this.formData, 'isSystemPhone', res.data.isSystemPhone ? true : false);
        }

        if (res.data.regAddr) {
          this.$set(this.formData, 'regAddr', res.data.regAddr);
        }

        if (res.data.idCardExpireTime) {
          this.$set(this.formData, 'idCardExpireTime', this.$utils.toDateString(res.data.idCardExpireTime, "yyyy-MM-dd"));
        }

        if (res.data.idcardBackUrl) {
          this.$set(this.formData, 'idcardBackUrl', res.data.idcardBackUrl);
        }
        if (res.data.idcardFrontUrl) {
          this.$set(this.formData, 'idcardFrontUrl', res.data.idcardFrontUrl);
        }
        if (res.data.idcardNum) {
          this.$set(this.formData, 'idcardNum', res.data.idcardNum);
        }
        if (res.data.driverBeginTime) {
          this.$set(this.formData, 'driverBeginTime', this.$utils.toDateString(res.data.driverBeginTime, "yyyy-MM-dd"));
        }
        if (res.data.driverExpireTime) {
          this.$set(this.formData, 'driverExpireTime', this.$utils.toDateString(res.data.driverExpireTime, "yyyy-MM-dd"));
        }

        if (res.data.driverCardNum) {
          this.$set(this.formData, 'driverCardNum', res.data.driverCardNum);
        } else {
          this.$set(this.formData, 'driverCardNum', this.formData.idcardNum);
        }

        if (res.data.driverModel) {
          this.$set(this.formData, 'driverModel', res.data.driverModel);
        }
        if (res.data.drivingCardFrontUrl) {
          this.$set(this.formData, 'drivingCardFrontUrl', res.data.drivingCardFrontUrl);
        }
        if (res.data.drivingCardSubpageUrl) {
          this.$set(this.formData, 'drivingCardSubpageUrl', res.data.drivingCardSubpageUrl);
        }
        if (res.data.qualificationUrl) {
          this.$set(this.formData, 'qualificationUrl', res.data.qualificationUrl);
        }
        if (res.data.transportLicenseNum) {
          this.$set(this.formData, 'transportLicenseNum', res.data.transportLicenseNum);
        } else {
          this.$set(this.formData, 'transportLicenseNum', this.formData.idcardNum);
        }
        if (res.data.transportExpireTime) {
          this.$set(this.formData, 'transportExpireTime', this.$utils.toDateString(res.data.transportExpireTime, "yyyy-MM-dd"));
        }
        if (res.data.issueAuthority) {
          this.$set(this.formData, 'issueAuthority', res.data.issueAuthority);
        }
        if (res.data.weightType) {
          this.$set(this.formData, 'weightType', res.data.weightType);
        }
      }
      // else {
      //   this.$XModal.alert({
      //     message: res.message ? res.message : "接口异常",
      //     status: "error",
      //   });
      // }
    },
    async getHomePort() {
      showLoading()
      let res = await $api.xcwDict.request('queryProCityAreaList');
      hideLoading();
      if (res.code === 1) {
        let province = [];
        res.data.map(i => {
          if (i.cityCodeP === '0') {
            province.push({
              label: i.cityText,
              value: i.cityCode,
              children: []
            })
          }
        })
        province.map(i => {
          res.data.map(j => {
            if (i.value === j.cityCodeP) {
              i.children.push({
                label: j.cityText,
                value: j.cityCode,
                children: []
              })
            }
          })
        })
        province.map(i => {
          i.children.map(j => {
            res.data.map(k => {
              if (j.value === k.cityCodeP) {
                j.children.push({
                  label: k.cityText,
                  value: k.cityCode,
                })
              }
            })
          })
        })

        this.home_port = province;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    inputIdCardNum(scope) {
      this.formData.driverCardNum = this.formData.idcardNum;
      this.formData.transportLicenseNum = this.formData.idcardNum;
      this.$refs.xForm.updateStatus(scope);
    },
    getOcrDriving(data) {
      if (data.zhenghao) {
        this.$set(this.formData, 'driverCardNum', data.zhenghao);
      }
      if (data.zhunjiachexing) {
        let driverModel = null;
        this.driver_model.map(i => {
          if (i.label === data.zhunjiachexing) {
            driverModel = i.value;
          }
        })
        this.$set(this.formData, 'driverModel', driverModel);
      }
      if (data.fazhengdanwei) {
        this.$set(this.formData, 'issueAuthority', data.fazhengdanwei);
      }
      if (data.youxiaoqishiriqi) {
        let date = this.insertStr(data.youxiaoqishiriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        this.$set(this.formData, 'driverBeginTime', date);
      }
      if (data.shixiaoriqi) {
        let date = this.insertStr(data.shixiaoriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        this.$set(this.formData, 'driverExpireTime', date);
      }
    },
    insertStr(source, start, newStr) {
      return source.slice(0, start) + newStr + source.slice(start)
    },
    getOcrIdCard(data) {
      if (data.xingming) {
        this.$set(this.formData, 'realName', data.xingming);
      }
      if (data.shenfenzhenghaoma) {
        this.$set(this.formData, 'idcardNum', data.shenfenzhenghaoma);
      }
      if (this.formData.userCategoryStr.indexOf('司机') > -1) {
        this.$set(this.formData, 'driverCardNum', data.shenfenzhenghaoma);
        this.$set(this.formData, 'transportLicenseNum', data.shenfenzhenghaoma);
      }

      if (data.zhuzhi) {
        this.$set(this.formData, 'regAddr', data.zhuzhi);
      }
    },
    isDefaultChange(row, $rowIndex) {
      if (row.isDefault == 1) {
        this.$refs.xBankTable.getTableData().fullData.forEach((item, index) => {
          if (index != $rowIndex) {
            item.isDefault = 0;
          }
        })
      }
    },
    async getBankListByName(row) {
      let name = row.openBankName;
      if (isEmpty(name)) {
        this.bankList = [];
        return
      }
      let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
      if (res.status == 1 && res.message === name) {
        this.bankList = res.data;
      }
    },
    bankFocusEvent(row, name) {
      row.chooseBank = false;
      this.$refs[name].showPanel();
    },
    bankKeyupEvent(row) {
      this.getBankListByName(row);
    },
    bankSelectEvent(obj, row, name) {
      row.chooseBank = true;
      row.openBankName = obj.orgName;
      row.openOrgNum = obj.orgNum;
      this.$refs[name].hidePanel();
    },
    checkOrg(row) {
      if (!row.openOrgNum || !row.chooseBank) {
        row.openBankName = '';
      }
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    getDicUserCategoryList() {
      let self = this
      self.userCategoryData = {options: []}
      $api.other.getDicUserCategoryModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictCode
              }
              self.userCategoryData.options.push(obj);
            });
          });
    },
    clickUserCategory(val) {
      if (this.formData.userCategoryStr.indexOf('司机') > -1) {
        this.formData.driverCardNum = this.formData.idcardNum;
        this.formData.transportLicenseNum = this.formData.idcardNum;
      }
      this.$forceUpdate();
    },
    async submitEvent() {
      let self = this;
      this.loading = true;
      if (this.formData.realName == null || this.formData.realName === "") {
        this.$XModal.alert({
          message: "请输入姓名",
          status: "error",
        });
        this.loading = false;
        return;
      }

      if (this.formData.realName && this.formData.realName !== '') {
        let regName = new RegExp(/^[\u4e00-\u9fa5]+$/);
        if (!regName.test(this.formData.realName)) {
          this.$XModal.alert({
            message: "请输入正确的姓名",
            status: "error",
          });
          this.loading = false;
          return;
        }
      }


      let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
      let validPhone = regPhone.test(this.formData.regisiterNum);
      if (this.formData.isSystemPhone) {
        if (this.formData.regisiterNum && this.formData.regisiterNum !== '' && this.formData.regisiterNum.length !== 11 && !validPhone) {
          this.$XModal.alert({
            message: "请输入正确的注册手机号",
            status: "error",
          });
          this.loading = false;
          return;
        }
      } else {
        if (!validPhone || !this.formData.regisiterNum) {
        this.$XModal.alert({
          message: "请输入正确的注册手机号",
          status: "error",
        });
        this.loading = false;
        return;
      }
      }

      if (this.formData.userCategoryStr.length === 0) {
        this.$XModal.alert({
          message: "请选择身份类型",
          status: "error",
        });
        this.loading = false;
        return;
      }

      let validPhoneNum = regPhone.test(this.formData.phoneNum);
      if (this.formData.phoneNum && this.formData.phoneNum !== '' && !validPhoneNum) {
        this.$XModal.alert({
          message: "请输入正确的联系方式",
          status: "error",
        });
        this.loading = false;
        return;
      }

      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      let validIDre = _IDRe18.test(this.formData.idcardNum) || _IDre15.test(this.formData.idcardNum);
      if (this.formData.idcardNum && this.formData.idcardNum !== '' && this.formData.idcardNum.length !== 18 && !validIDre) {
        this.$XModal.alert({
          message: "请输入正确的身份证号码",
          status: "error",
        });
        this.loading = false;
        return;
      }

      self.copyTemp();
      if (this.formDataCopy.regisiterNum && this.formDataCopy.regisiterNum !== '') {
        if (!this.formData.isSystemPhone) {
          this.getWYMIdlephoneCheck();
        } else {
          this.createAndSaveBaseUserSign();
        }
      } else {
        this.createAndSaveBaseUserSign();
      }
    },
    async createAndSaveBaseUserSign() {
      this.formDataCopy.regisiterNumState = this.regisiterNumState;
      showLoading();
      let res = await $api.gcdUser
          .request("createAndSaveBaseUserSign", this.formDataCopy)
          .catch(function (er) {
            console.log(er.response.data.message);
            self.$XModal.alert({
              message: er.response.data.message
                  ? er.response.data.message
                  : "接口异常",
              status: "error",
            });
            return;
          });
      hideLoading();
      if (res.status == 1) {
        this.$Message["success"]({
          background: true,
          content: "创建成功",
        });
        this.wyTip = false;
        this.msg = '';
        // debugger
        this.close();
        window.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    async getWYMIdlephoneCheck() {
      showLoading();
      let obj = Object.assign({}, this.formDataCopy);
      showLoading();
      let res = await $api.gcdUser.post("getAliphoneCheck", {
        regisiterNum: obj.regisiterNum
      });
      hideLoading();
      if (res.status === 1) {
        let data = res.data;
        let phoneInfo = res.data.phoneInfo[0];
        if (data.status === 2) {
          this.msg = '校验失败';
          this.wyTip = true;
          this.msgErr = data.isPayed === 1;
        }
        this.regisiterNumState = phoneInfo.aliStatus;
        let errMsg = {
          2:'手机号停机',
          6:'手机号关机',
          0:'手机号空号',
          7:'手机号疑似关机',
          8:'手机号忙',
        }

        if(phoneInfo.aliStatus === null) {
          this.msg = phoneInfo.message;
          this.wyTip = true;
        } else if (phoneInfo.aliStatus === 1) {
          this.formDataCopy.carrier = phoneInfo.carrier
          this.createAndSaveBaseUserSign();
        } else {
          this.msg = errMsg[phoneInfo.aliStatus] ?? "手机号未知";
          this.wyTip = true;
          this.msgErr = data.isPayed === 1;
        }
        // if (phoneInfo.aliStatus === 0) {
        //   this.msg = '该手机号为空号';
        //   this.wyTip = true;
        //   this.msgErr = data.isPayed === 1;
        // }  else if(phoneInfo.aliStatus === null) {
        //   this.msg = phoneInfo.message;
        //   this.wyTip = true;
        // } else {
        //   this.formDataCopy.carrier = phoneInfo.carrier
        //   this.createAndSaveBaseUserSign();
        // }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cancelCreate() {
      this.wyTip = false;
      this.msg = '';
    },
    close() {
      window.close();
      this.$bus.$emit("closeProcedureDetail", '新建个人客户');
      this.$bus.$emit("afterCreatePerson", true);

      this.formData = {
        compName: null,
        faxNum: null,
        idcardNum: null,
        idCardExpireTime: null,
        regisiterNum: null,
        driverCardNum: null,
        driverModel: null,
        issueAuthority: null,
        driverBeginTime: null,
        driverExpireTime: null,
        weightType: null,
        transportLicenseNum: null,
        transportExpireTime: null,
        phoneNum: null,
        realName: null,
        regAddr: null,
        regPhone: null,
        taxNum: null,
        accountName: null,
        accountNum: null,
        isSystemPhone: false,
        userCategoryStr: [],
        userType: 1,
        userAddressBankInfo: [
          {
            accountName: null,
            accountNum: null,
            openBankName: null,
            openOrgNum: null
          },
        ],
        userAddressInfor: [
          {
            content: null,
            linkMan: null,
            linkPhone: null,
          },
        ],
      };
      this.tableData = [{
        isDefault: 1
      }];
      this.tableData2 = [{
        pro: []
      }];

      this.authTrue = false;
      this.driverTrue = false;
      this.$refs.xForm.clearValidate();
    },
    insertEvent(row) {
      let record = {
        isDefault: 1
      };
      if (this.$refs.xBankTable.getTableData().tableData.length === 0) {
        record.isDefault = 1
        this.$refs.xBankTable.insertAt(record, row);
      } else {
        record.isDefault = 0
        this.$refs.xBankTable.insertAt(record, row);
      }
    },
    insertEvent2(row) {
      let record = {
        pro: []
      };
      this.$refs.xEmailTable.insertAt(record, row);
    },
    copyTemp() {
      this.formDataCopy = {
        userAddressBankInfo: [],
        userAddressInfor: [],
      };

      if (this.formData.password == null || this.formData.password == "") {
        this.formDataCopy.password = md5("666888");
      } else {
        this.formDataCopy.password = md5(this.formData.password);
      }
      this.formDataCopy.userCategoryStr = this.formData.userCategoryStr.toString();
      this.formDataCopy.transportLicenseUrl = this.formData.transportLicenseUrl;
      if (this.formData.businessExpireTime) {
        this.formDataCopy.businessExpireTime = this.$utils.timestamp(this.formData.businessExpireTime);
      }
      this.formDataCopy.businessLicenseNum = this.formData.businessLicenseNum;
      this.formDataCopy.drivingCardFrontUrl = this.formData.drivingCardFrontUrl;
      this.formDataCopy.qualificationUrl = this.formData.qualificationUrl;
      this.formDataCopy.drivingCardSubpageUrl = this.formData.drivingCardSubpageUrl;
      this.formDataCopy.userType = this.formData.userType;
      if (this.formData.realName && this.formData.realName !== '') {
        this.formDataCopy.realName = this.formData.realName.replace(/\s*/g, "");
        this.formDataCopy.userName = this.formData.realName.replace(/\s*/g, "");
      }
      this.formDataCopy.faxNum = this.formData.faxNum;
      this.formDataCopy.idcardNum = this.formData.idcardNum;
      this.formDataCopy.phoneNum = this.formData.phoneNum;
      this.formDataCopy.regAddr = this.formData.regAddr;
      this.formDataCopy.regPhone = this.formData.regPhone;
      this.formDataCopy.taxNum = this.formData.taxNum;
      this.formDataCopy.openBankName = this.formData.openBankName;
      this.formDataCopy.openOrgNum = this.formData.openOrgNum;
      this.formDataCopy.accountNum = this.formData.accountNum;

      this.formDataCopy.aboutCompId = this.formData.aboutCompId;
      this.formDataCopy.aboutCompName = this.formData.aboutCompName;
      if (this.formData.accountName && this.formData.accountName !== '') {
        this.formDataCopy.accountName = this.formData.accountName.replace(/\s*/g, "");
      }
      this.formDataCopy.idcardBackUrl = this.formData.idcardBackUrl;
      this.formDataCopy.businessUrl = this.formData.businessUrl;
      this.formDataCopy.idcardFrontUrl = this.formData.idcardFrontUrl;
      this.formDataCopy.linkman = this.formData.linkman;
      this.formDataCopy.managerType = this.formData.managerType;
      this.formDataCopy.managerPhone = this.formData.managerPhone;
      this.formDataCopy.managerName = this.formData.managerName;
      this.formDataCopy.isSystemPhone = this.formData.isSystemPhone ? 1 : 0;

      if (this.formData.idCardExpireTime) {
        this.formDataCopy.idCardExpireTime = this.$utils.timestamp(this.formData.idCardExpireTime);
      }
      this.formDataCopy.regisiterNum = this.formData.regisiterNum;
      this.formDataCopy.driverCardNum = this.formData.driverCardNum;
      this.formDataCopy.driverModel = this.formData.driverModel;
      this.formDataCopy.issueAuthority = this.formData.issueAuthority;
      if (this.formData.driverBeginTime) {
        this.formDataCopy.driverBeginTime = this.$utils.timestamp(this.formData.driverBeginTime);
      }
      if (this.formData.driverExpireTime) {
        this.formDataCopy.driverExpireTime = this.$utils.timestamp(this.formData.driverExpireTime);
      }
      this.formDataCopy.weightType = this.formData.weightType;
      this.formDataCopy.transportLicenseNum = this.formData.transportLicenseNum;
      if (this.formData.transportExpireTime) {
        this.formDataCopy.transportExpireTime = this.$utils.timestamp(this.formData.transportExpireTime);
      }

      if (this.$refs.xBankTable != null) {
        this.formDataCopy.userAddressBankInfo = this.copyDeep(
            this.$refs.xBankTable.getTableData().fullData
        );
        let deleteArr = [];
        this.formDataCopy.userAddressBankInfo.map((i, index) => {
          if (!i.accountName && !i.accountNum && !i.openBankName) {
            deleteArr.push(index);
          }
        })
        deleteArr.map(i => {
          delete this.formDataCopy.userAddressBankInfo[i];
        })
      }
      if (this.$refs.xEmailTable != null) {
        this.formDataCopy.userAddressInfor = this.copyDeep(
            this.$refs.xEmailTable.getTableData().fullData
        );
        this.formDataCopy.userAddressInfor.map(i => {
          if (i.pro && i.pro.length > 0) {
            i.pro = i.pro.toString();
          } else {
            i.pro = null;
          }
        })

        let deleteArr = [];
        this.formDataCopy.userAddressInfor.map((i, index) => {
          if (!i.content && !i.linkMan && !i.linkPhone && !i.pro) {
            deleteArr.push(index);
          }
        })
        deleteArr.map(i => {
          delete this.formDataCopy.userAddressInfor[i];
        })
      }
    },
    copyDeep(templateData) {
      // templateData 是要复制的数组或对象，这样的数组或者对象就是指向新的地址的
      return JSON.parse(JSON.stringify(templateData));
    },
    delRow(e) {
      this.$refs.xBankTable.remove(e);
    },
    delRow2(e) {
      this.$refs.xEmailTable.remove(e);
    },
  }
}
</script>
<style>
body {
  overflow: scroll !important;
}

.StepCss {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.StepCss > .ivu-steps {
  width: 50%;
}

.flexCss {
  display: flex;
  justify-content: center;
}

.fontWeight {
  font-weight: 800;
  margin-bottom: 10px;
  color: #2d8cf0;
  display: inline-block;
}

.infoCssPadding {
  width: 100%;
}

.vxe-form .infoCssPadding .vxe-form--item {
  display: none;
  width: 100%;
}

/*.infoCssPadding .vxe-input:not(.is--disabled).is--active .vxe-input--inner {*/
/*  border: 0px solid #409eff;*/
/*}*/

.infoCssPadding .vxe-input--inner {
  width: 100%;
  height: 100%;
  /* border-radius: 4px; */
  outline: 0;
  padding: 0 0.6em;
  color: #606266;
  /*border: 0px solid #dcdfe6;*/
  background-color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.inputWidthCss .vxe-input input {
  max-width: 300px;
}

.inputWidthCss .ivu-row {
  border-bottom: 1px solid rgba(232, 234, 236, 1);
}

.infoCssPadding .ivu-btn-icon-only {
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 16px;
  border-radius: 4px;
}

.upload-list2-wrap {
  display: flex;
  flex-wrap: wrap;
}

.upload-list2 {
  display: inline-block;
  width: 120px;
  height: 120px;
  text-align: center;
  line-height: 120px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.2);
  margin-left: 4px;
  vertical-align: middle;
  margin-bottom: 10px;
}

.upload-list2 img {
  width: 100%;
  height: 100%;
  border-style: none;
}

.add-box .file-upload-box2 {
  height: 120px;
  width: 120px;
  line-height: 120px;
  border: 1px dashed #dcdee2;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.upload-list2:hover .upload-list2-cover {
  display: block;
}

.upload-list2-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.upload-list2-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}

.upload-list2 .pdf-box2 {
  height: 120px;
  width: 120px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}

.bit {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.bit-tip {
  width: 4px;
  height: 16px;
  background: #539FFF;
}

.bit-title {
  margin-left: 4px;
  height: 21px;
  line-height: 21px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #438DF3;
}

.formInput {
  max-width: 300px;
}

.my-dropdown1 {
  height: 200px;
  overflow: auto;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
}

.list-item1:hover {
  background-color: #f5f7fa;
}

.border-shadow {
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
  padding: 20px 30px;
  box-sizing: border-box;
}

.border-shadow .ivu-row {
  display: flex;
  align-items: center;
}

.re-switch {
  width: 70px;
  margin-right: 10px;
}

.ivu-switch-checked:after {
  left: 48px !important;
}
</style>